import { useEffect, useState } from "react";
import { BRAND_ASSETS } from "./constants";

export function BrandedLoading({
  message = "Loading",
  help,
  helpVisible = false,
  action,
}: {
  message?: string;
  help?: string;
  helpVisible?: boolean;
  action?: { label: string; onClick: () => void };
}) {
  const [showHelp, setShowHelp] = useState(helpVisible);

  useEffect(() => {
    if (helpVisible) {
      setShowHelp(true);
      return;
    }
    const timer = window.setTimeout(() => setShowHelp(true), 8000);
    return () => window.clearTimeout(timer);
  }, [helpVisible]);

  return (
    <div className="loading branded-loading" role="status" aria-live="polite">
      <span className="brand-mark branded-loading-logo" aria-hidden="true">
        <img className="brand-mark-light" src={BRAND_ASSETS.markLight} alt="" />
        <img className="brand-mark-dark" src={BRAND_ASSETS.markDark} alt="" />
      </span>
      <span className="sr-only">{message}</span>
      {showHelp && (
        <div className="branded-loading-footer">
          <p className="branded-loading-help">
            {help || "This is taking longer than expected. Check your connection, then refresh the page."}
          </p>
          {action ? (
            <button className="button secondary branded-loading-action" type="button" onClick={action.onClick}>
              {action.label}
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
}
